<template>
  <div>
    <a-modal
      title="AI翻译"
      :visible="visible"
      v-bind="drawerConfig"
      :body-style="{ paddingBottom: '80px' }"
      @cancel="onClose"
    >
      <a-spin :spinning="spinning">
        <div class="form_tab result" v-if="result">
          <div class="" v-if="data.translate == 1">
            <a-form-model
              ref="ruleForm"
              :model="form"
              :rules="rules"
              v-bind="layout"
            >
              <a-form-model-item label="源语言">
                <span style="margin-right: 20px;">{{
                  data.main_langset_name
                }}</span>
              </a-form-model-item>
              <a-form-model-item
                ref="a_langset_id"
                label="目标语言"
                prop="a_langset_id"
                :help="formErr.a_langset_id"
                :validateStatus="
                  !formErr.a_langset_id || formErr.a_langset_id == ''
                    ? ''
                    : 'error'
                "
                class="seachsboxss"
                style="position: relative;"
              >
                <a-select
                  v-model="form.a_langset_id"
                  @change="optionLangsetChange"
                  mode="multiple"
                  class="seachs"
                  allowClear
                  dropdownClassName="seachsSelectBatchTranslation"
                >
                  <a-select-option :value="0">
                    <p>全选</p>
                  </a-select-option>
                  <a-select-option
                    :disabled="disabledLangset"
                    :value="item.id"
                    :key="item.id" v-for="item in data.langset"
                    :class="{
                      activeOption: optionLangsetId.indexOf(item.id) >= 0,
                    }"
                  >
                    <p>{{ item.name }}</p>
                  </a-select-option>
                </a-select>
                <!--                <a-button type="primary" @click="onSubmit" style="position: absolute;right:-110px;top:-6px">确认翻译-->
                <!--                </a-button>-->
              </a-form-model-item>
            </a-form-model>
            <a-alert
              :message="
                data.friendly_tips ||
                '友情提示：翻译比较多内容时可能需要一些时间，请您耐心等待！'
              "
              type="warning"
              show-icon
            />
          </div>
          <div
            v-else
            style="font-size: 22px; text-align: center; margin-top: 50px;"
          >
            <p>翻译字符超出剩余字符数，请购买字符后再翻译！</p>
            <a-button @click="data.translate = 1" style="margin-top: 160px;">
              关闭
            </a-button>
          </div>
        </div>
        <div class="result" v-else>
          <!--          <a-result-->
          <!--              status="success"-->
          <!--              title="翻译完成"-->
          <!--              :sub-title="resultText"-->
          <!--          >-->
          <!--          </a-result>-->
          <div
            class="result"
            style="font-size: 22px; text-align: center; margin-top: 50px;"
          >
            <p>翻译任务已提交，</p>
            <p>请稍后前往翻译日志查看</p>
          </div>
        </div>
        <!--        <div class="drawer-btn" style="position: fixed!important;width: 720px!important;right: 0!important;">-->
        <!--          <a-button @click="onClose">-->
        <!--            关闭-->
        <!--          </a-button>-->
        <!--        </div>-->
      </a-spin>

      <template #footer>
        <div v-if="result && data.translate == 1" style="text-align: center;">
          <a-button key="back" @click="onSubmit" type="primary">确定</a-button>
          <a-button key="submit" @click="onClose">取消</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { submitForm, drawerConfig, validator } from "../../../../utils/utils";
import API from "../api";
export default {
  name: "newForm",
  props: ["visible", "title", "productids", "customerid"],
  data() {
    return {
      disabledLangset: false,
      translate: 1,
      optionLangsetName: "",
      optionLangsetId: [],
      translateNum: 0,
      result: true,
      resultText: [],
      drawerConfig,
      spinning: true,
      a_langset_id_copy: [],
      form: {
        a_langset_id: [],
      },
      formErr: {
        a_langset_id: "",
      },
      rules: {
        a_langset_id: [
          { required: true, message: "请输入目标语言 ", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.a_langset_id);
            },
            trigger: "blur",
          },
        ],
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      },
      data: {
        translate: 1,
        translation_surplus_num: "",
        translation_need_num: "",
        char_summary_text: "",
        main_langset_name: "",
        langset: [],
        is_deduct_char_num: 1,
        translation_source: 1,
      },
      titles: "",
      type: 1,
    };
  },
  watch: {
    visible: function (a, b) {
      if (a == true) {
        let params = {
          a_customer_id: this.customerid,
          product_ids: this.productids,
        };

        API.service.TRANSLATE_CHECK(params).then((res) => {
          // this.data=res.data.data
          if (this.data.translate == 1) {
            this.type = 2;
          }
          this.titles = `${this.title}(剩余字符数${res.data.data.translation_surplus_num})`;
          this.data.translation_surplus_num =
            res.data.data.translation_surplus_num;
          this.data.translation_need_num = res.data.data.translation_need_num;
          this.data.char_summary_text = `确定要批量翻译吗？剩余字符${res.data.data.translation_surplus_num}个，本次翻译需要${this.data.translation_need_num}字符。`;
          this.data.main_langset_name = res.data.data.main_langset_name;
          this.data.langset = res.data.data.langset;
          this.data.translation_source = res.data.data.translation_source;
          this.data.is_deduct_char_num =
            res.data.data.is_deduct_char_num == 1 ? true : false;
          this.spinning = false;
        });
      }
    },
  },
  methods: {
    optionLangsetChange(value, option) {
      console.log("value", value);
      console.log("option", option);
      console.log("option---", option.componentOptions);
      if (value.length == this.data.langset.length) {
        if (!value.includes(0)) {
          //所有语种都选中
          this.form.a_langset_id = [...value, 0];
        }
      }
      //当前点击的全选
      if (value.includes(0) && !this.a_langset_id_copy.includes(0)) {
        //选过单语种，点击全选
        this.form.a_langset_id = this.data.langset.map((item) => {
          return item.id;
        });
        this.form.a_langset_id = [...this.form.a_langset_id, 0];
      } else {
        //取消全选
        if (!value.includes(0) && this.a_langset_id_copy.includes(0)) {
          this.form.a_langset_id = [];
        } else {
          if (value.includes(0)) {
            this.form.a_langset_id.splice(
              this.form.a_langset_id.findIndex((item) => {
                return item == 0;
              })
            );
          }
        }
      }

      this.a_langset_id_copy = this.form.a_langset_id;
      //  let name=this.data.langset.filter(item => {
      //    if(item.id==value)return item.name
      //  } )
      // this.optionLangsetName= name[0].name
      let langsetNum;
      if (this.a_langset_id_copy.length > 0) {
        if (this.a_langset_id_copy.includes(0)) {
          langsetNum = this.a_langset_id_copy.length - 1;
        } else {
          langsetNum = this.a_langset_id_copy.length;
        }
      } else {
        langsetNum = 1;
      }
      this.data.char_summary_text = `确定要批量翻译吗？剩余字符${
        this.data.translation_surplus_num
      }个，本次翻译需要${this.data.translation_need_num * langsetNum}字符。`;
    },
    onClose() {
      if (!this.spinning) {
        this.$emit("changVisible", false);
        this.formErr = { a_langset_id: "" };
        this.a_langset_id_copy = [];
        this.data = {
          translate: 1,
          translation_surplus_num: "",
          translation_need_num: "",
          char_summary_text: "",
          main_langset_name: "",
          langset: [],
          is_deduct_char_num: 1,
          translation_source: 1,
        };
        (this.result = true),
          (this.resultText = []),
          (this.optionLangsetId = []);
        (this.spinning = true), (this.form = { a_langset_id: [] });
        this.type = 1;
      }
      // this.$emit("changVisible", false);
    },

    onSubmit() {
      let _this = this;
      // if(!this.data.is_deduct_char_num){
      //   if (this.data.translation_need_num * this.form.a_langset_id.length > this.data.translation_surplus_num) {
      //     _this.data.translate = 2
      //     return
      //   } else {

      //   }
      // }
      _this.data.translate = 1;
      this.submitFn();
    },
    submitFn() {
      let _this = this;
      _this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let langsetArr = JSON.parse(JSON.stringify(_this.form.a_langset_id));
          if (langsetArr.includes(0)) {
            langsetArr.splice(
              langsetArr.findIndex((item) => {
                return item == 0;
              })
            );
          }
          let form = {
            a_langset_ids: langsetArr,
            a_customer_id: _this.customerid,
            product_ids: _this.productids,
          };
          _this.optionLangsetId.push(_this.form.a_langset_id);
          _this.spinning = true;
          API.service.TRANSLATE_AI(form).then((res) => {
            _this.result = false;
            _this.spinning = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
p {
  margin: 0 !important;
}
.result {
  min-height: 350px;
}
</style>
<style>
.seachsSelectBatchTranslation .activeOption {
  background-color: #1890ff !important;
  color: #fff;
}
</style>
